import { ThemeOptions } from '@mui/material/styles';
import { baseShape, baseTypography } from './baseTheme';

/**
 * Corporate Blue Theme
 * Primary: Deep Blue (#0d47a1)
 * Secondary: Orange (#ff6f00)
 * Target: Enterprise
 */
export const corporateBlueTheme: ThemeOptions = {
    palette: {
        mode: 'light',
        primary: {
            main: '#0d47a1',
            light: '#5472d3',
            dark: '#002171',
            contrastText: '#fff',
        },
        secondary: {
            main: '#ff6f00',
            light: '#ffa040',
            dark: '#c43e00',
            contrastText: '#fff',
        },
        background: {
            default: '#f0f2f5',
            paper: '#ffffff',
        },
        text: {
            primary: '#263238',
            secondary: '#546e7a',
        },
        error: {
            main: '#d32f2f',
        },
        warning: {
            main: '#f57c00',
        },
        info: {
            main: '#0288d1',
        },
        success: {
            main: '#388e3c',
        },
    },
    typography: {
        ...baseTypography,
        h1: {
            fontWeight: 700,
        },
        h2: {
            fontWeight: 700,
        },
        h6: {
            fontWeight: 700,
        },
    },
    shape: baseShape,
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontWeight: 600,
                    boxShadow: 'none',
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12)',
                    border: '1px solid #e0e0e0',
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: '#0d47a1',
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#ffffff',
                    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.08)',
                },
            },
        },
    },
};
